import React, { useRef } from 'react';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';

type CarouselLinkProps = {
  href: string;
  title: string;
  className: string;
  tooltipPlacement: TooltipPlacement;
};
export function CarouselLink({ href, title, className, tooltipPlacement }: CarouselLinkProps) {
  const aRef = useRef<HTMLAnchorElement>(null);

  /**
   * Progressive Enhancement: without JS it would work anyway, but jump to top left corner of the image gallery.
   * @param event
   */
  const scrollToIdHorizontally = (event: React.MouseEvent) => {
    event.preventDefault();

    const idWithoutHash = href.replace('#', '');
    const element = document.getElementById(idWithoutHash);
    const scrollContainer = element?.parentNode as HTMLElement;

    if (element && scrollContainer) {
      scrollContainer.scroll({
        left: element.offsetLeft,
        behavior: 'smooth',
      });

      window.scrollTo({
        top: window.scrollY,
        behavior: 'smooth',
      });
    }
  };
  return (
    <Tooltip attachTo={aRef} placement={tooltipPlacement} hideTooltipFromScreenReader>
      <a
        ref={aRef}
        href={href}
        title={title}
        className={className}
        onClick={(event: React.MouseEvent) => {
          scrollToIdHorizontally(event);
        }}
      >
        <span className="invisible">{title}</span>
      </a>
    </Tooltip>
  );
}
